import {UserModel, UserRoleType} from '@core/api/data-access';
import {IUserFormStruct} from './user-form.types';

export const CommunicationPreference = {
	none: null,
	notifyEmail: 'notifyEmail',
	notifySMS: 'notifySMS',
	notifyWhatsapp: 'notifyWhatsapp',
} as const;

export class UserFormModel {
	public readonly userModel: UserModel;
	public communicationPreference: (typeof CommunicationPreference)[keyof typeof CommunicationPreference] = CommunicationPreference.none;
	public password: string = '';
	constructor(user: UserModel) {
		this.userModel = user instanceof UserModel ? user : new UserModel(user);
		this.setCommunicationPreference(user);
	}

	public setCommunicationPreference(user: UserModel): void {
		if (user.preferences.notifyEmail && user.email) {
			this.communicationPreference = CommunicationPreference.notifyEmail;
		} else if (user.preferences.notifySMS && user.phonenumber) {
			this.communicationPreference = CommunicationPreference.notifySMS;
		} else if (user.preferences.notifyWhatsapp && user.phonenumber) {
			this.communicationPreference = CommunicationPreference.notifyWhatsapp;
		} else {
			this.communicationPreference = CommunicationPreference.none;
		}
	}

	public updateFrom(userValue: Partial<IUserFormStruct>): void {
		Object.keys(userValue).forEach(key => {
			if (key in this.userModel) {
				this.userModel[key] = userValue[key];
			} else if (key in this) {
				this[key] = userValue[key];
			}
			switch (key) {
				case 'communicationPreference':
					this.userModel.preferences.notifyEmail = this.communicationPreference === CommunicationPreference.notifyEmail;
					this.userModel.preferences.notifySMS = this.communicationPreference === CommunicationPreference.notifySMS;
					this.userModel.preferences.notifyWhatsapp = this.communicationPreference === CommunicationPreference.notifyWhatsapp;
					break;
				case 'password':
					this.password = userValue[key];
					break;
				case 'permissions':
					const permissions = userValue[key];
					this.userModel.roles = Object.keys(permissions)
						.filter(key => permissions[key])
						.map(key => key as UserRoleType);
					break;
				case 'dateFormat':
					this.userModel.preferences.dateFormat = userValue[key];
					break;
				case 'daysToReminder':
					this.userModel.preferences.daysToReminder = userValue[key];
					break;
				case 'penColor':
					this.userModel.preferences.penColor = userValue[key];
					break;
				case 'penWidth':
					this.userModel.preferences.penWidth = userValue[key];
					break;
			}
		});
	}
}
